import React from 'react';
import PropTypes from 'prop-types';
import { withGoogleMap, GoogleMap, Marker } from 'react-google-maps';

class Map extends React.Component {
  static propTypes = {
    defaultZoom: PropTypes.number,
    defaultCenter: PropTypes.shape({
      lat: PropTypes.number,
      lng: PropTypes.number,
    }),
    markers: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        position: PropTypes.shape({
          lat: PropTypes.number,
          lng: PropTypes.number,
        }),
      }),
    ),
  };
  static defaultProps = {
    defaultZoom: 15,
    defaultCenter: { lat: 49.441129, lng: 32.04981 },
    markers: [],
  };

  render() {
    return (
      <GoogleMap defaultZoom={this.props.defaultZoom} defaultCenter={this.props.defaultCenter}>
        {this.props.markers.map(marker => {
          if (!marker) {
            return null;
          }
          return <Marker key={`${marker.position.lat} ${marker.position.lng}`} {...marker} />;
        })}
      </GoogleMap>
    );
  }
}

export default withGoogleMap(Map);



// WEBPACK FOOTER //
// ./src/shared/components/Map/Map.js